import PersonalInfo from "./PersonalInfo";
import SecurityInfo from "./SecurityInfo";
import RegisteredAreasDepartments from "./RegisteredAreasDepartments";
import { UpdateProfileSnackbar, MaxFileSizeSnackbar } from "./Snackbars";
import ViewQualificationInfoModal from "./ViewQualificationInfoModal";
import EditQualificationInfoModal from "./EditQualificationInfoModal";
import QualificationInfoPaper from "./QualificationInfoPaper";
import UserAnalytics from "./UserAnalytics";

export {
    PersonalInfo,
    SecurityInfo,
    RegisteredAreasDepartments,
    UpdateProfileSnackbar,
    MaxFileSizeSnackbar,
    ViewQualificationInfoModal,
    EditQualificationInfoModal,
    QualificationInfoPaper,
    UserAnalytics
};
